<template>
    <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('moh') }}</h4>
    <div>
      <div class="row">
        <div class="col-md-8">
        <recording-select :model="model" attribute="moh" :errors="formErrors"></recording-select>
        </div>
        <div class="col-md-4">
          <b-button :disabled="saveLoading" variant="primary" class="float-left" @click="save">
            <b-spinner v-if="saveLoading" small></b-spinner>
            {{ $t('save') }}
          </b-button>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
import RecordingSelect from "../../../../components/RecordingSelect";
export default {
    components: {RecordingSelect},
    data() {
      return {
        model: {},
        errors: {},
        formErrors: [],
        saveLoading: false,
      }
    },
    methods: {
    load() {
      this.$service.get('/client/setting').then(response => {
        this.model = {};
        this.model = response.data;
      }).finally(() => {
      });
    },
    save() {
      this.$service.put('/client/setting', this.model).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updated'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
        } else {
          this.errors = error.response.data;
        }
      });
    }
  },
  mounted() {
    this.load();
  }
}
</script>
<style scoped>

</style>